// components/schedule/ScheduleDialog/VehicleSelection.tsx

import React from 'react';
import { Button, Box, Chip, Typography, Grid } from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import WarningIcon from '@mui/icons-material/Warning';
import { VehicleSelectionProps } from './types';

export const VehicleSelection: React.FC<VehicleSelectionProps> = ({
  scheduleType,
  cars,
  currentVehicles,
  onCarSelect,
  onCarRemove,
  vehiclesWithOtherSchedules
}) => {
  // 現在選択されている車両IDの配列を取得
  const selectedCarIds = currentVehicles.map(v => v.Car_ID);

  return (
    <>
      {/* 選択された車両を表示 */}
      {currentVehicles.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>選択中の車両</Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {currentVehicles.map((vehicle, index) => (
              <Chip
                key={`selected-car-${index}-${vehicle.Car_ID}`}
                label={vehicle.Car_Nickname || `${vehicle.Car_Model || ''} ${vehicle.Car_Number || ''}`}
                onDelete={() => onCarRemove(vehicle.Car_ID)}
                color="primary"
                icon={<DirectionsCarIcon />}
              />
            ))}
          </Box>
        </Box>
      )}

      {/* 車両選択グリッド */}
      <Typography variant="subtitle2" sx={{ mb: 1 }}>車両を選択</Typography>
      <Grid container spacing={1.5}>
        {cars.map((car) => {
          const isSelected = selectedCarIds.includes(car.ID);
          // 車両の重複チェック - vehiclesWithOtherSchedulesが存在する場合のみチェック
          const hasConflict = vehiclesWithOtherSchedules ? 
            vehiclesWithOtherSchedules.includes(car.ID) : false;

          return (
            <Grid item xs={6} sm={4} key={`car-${car.ID}`}>
              <Button
                fullWidth
                variant={isSelected ? "contained" : "outlined"}
                color={isSelected ? "success" : hasConflict ? "warning" : "primary"}
                onClick={() => onCarSelect(car)}
                sx={{
                  height: '60px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  whiteSpace: 'normal',
                  lineHeight: 1.2,
                  ...(isSelected && {
                    fontWeight: 'bold',
                    boxShadow: 1
                  }),
                  ...(hasConflict && !isSelected && {
                    borderStyle: 'dashed',
                    borderWidth: 2
                  })
                }}
              >
                <Typography 
                  variant="body2" 
                  noWrap 
                  sx={{ 
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {car.Car_Nickname || car.Car_Model}
                  {hasConflict && !isSelected && (
                    <WarningIcon sx={{ ml: 0.5, fontSize: '0.9rem', color: 'warning.main' }} />
                  )}
                </Typography>
                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      fontSize: { xs: '0.7rem', sm: '0.75rem' },
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {car.Car_Number_4}
                  </Typography>
              </Button>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};